export default {
  ratePlanType: {
    STANDARD: 'मानक',
    BAR: 'बेस्ट अवेलेबल रेट',
    CORPORATE: 'कॉर्पोरेट',
    MEMBER: 'सदस्य',
    PACKAGE: 'पैकेज',
    PROMOTIONAL: 'प्रचार',
    OTA: 'OTA',
    WHOLESALE: 'थोक',
    NEGOTIATED: 'नेगोशिएटेड',
    MIXED: 'मिश्रित दर',
  },
} as const;
